import axios from "axios";

export function getBlockedStatus() {
  return axios.get(
    `${process.env.REACT_APP_SISAPI}/v1/acropolis/users/blocked-status`
  );
}
